// 全局挂载引入http相关请求拦截插件
import Request from '../luch-request'
const http = new Request()
export default http
